// @ts-nocheck -- TypeScript migration in progress: bulk-renamed from .js and not
// yet typed. Remove this directive and add real types when converting this
// module. Backlog: grep -rl "@ts-nocheck" src. See docs/typescript-migration.md.
// Normalized engine-monitor CSV export: per-cell formatting, column
// key inference, filename derivation, full text assembly, and the
// browser download trigger.

import { rawChannelKeysForData } from "../core/raw-metadata.js";
import { flightDateLabel } from "./flight-display-model.js";
import { reportFileName } from "../reporting/pdf-helpers.js";

export function csvEscape(value) {
  if (value === null || value === undefined) return "";
  const text = typeof value === "string"
    ? value
    : typeof value === "number" || typeof value === "boolean"
      ? String(value)
      : JSON.stringify(value);
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, "\"\"")}"` : text;
}

export function normalizedCsvCellValue(value) {
  if (!Number.isFinite(value)) return value ?? "";
  return String(value);
}

export function normalizedCsvColumnKeys(points = []) {
  const preferred = ["displayTime", "elapsedSeconds", "phase", "phaseSource"];
  const channelKeys = rawChannelKeysForData(points);
  const extras = new Set();
  points.forEach((point) => {
    Object.keys(point ?? {}).forEach((key) => {
      if (!preferred.includes(key) && !channelKeys.includes(key)) extras.add(key);
    });
  });
  return [
    ...preferred.filter((key) => points.some((point) => point?.[key] !== undefined && point?.[key] !== null && point?.[key] !== "")),
    ...channelKeys,
    ...[...extras].sort(),
  ];
}

export function normalizedCsvFileName(selectedFlight, points = []) {
  const first = points[0] ?? null;
  return reportFileName(selectedFlight, first, flightDateLabel).replace(/-engine-report\.pdf$/i, "-normalized-log.csv");
}

export function buildNormalizedCsvText(points = []) {
  const rows = Array.isArray(points) ? points : [];
  const keys = normalizedCsvColumnKeys(rows);
  const titleRow = ["Alary IQ", "Normalized Engine Monitor Log", "www.alaryiq.com"].map((value) => csvEscape(value)).join(",");
  const headers = keys.map((key) => csvEscape(key));
  const csvRows = rows.map((point) => keys.map((key) => csvEscape(normalizedCsvCellValue(point?.[key]))).join(","));
  return `${titleRow}\n${headers.join(",")}\n${csvRows.join("\n")}`;
}

export async function downloadNormalizedCsv({ selectedFlight, loadEnvelope }) {
  if (!selectedFlight) {
    window.alert("Load a flight log before downloading the normalized CSV.");
    return;
  }
  // Capture the flight before loading so navigation cannot pair another flight
  // with these samples or their filename. Export includes the review endpoints.
  const entry = structuredClone(selectedFlight);
  const envelope = await loadEnvelope(entry);
  const points = envelope?.points;
  if (!Array.isArray(points) || !points.length) {
    window.alert("Load a flight log before downloading the normalized CSV.");
    return;
  }
  const csvText = buildNormalizedCsvText(points);
  const blob = new Blob([csvText], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = normalizedCsvFileName(entry, points);
  link.rel = "noopener";
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
